import { ROUTES } from './Estimate/common/routes';

export const url = {
  login: {
    path: '/pro/log_in',
  },
  logout: {
    path: '/pro/log_out',
  },
  proRedirect: {
    path: '/pro',
  },
  settings: {
    path: '/pro/account',
    appPath: '/app/settings',
  },
  employeesSettings: {
    appPath: '/app/settings/employees',
  },
  myAccount: {
    path: '/pro/account/employees/my_account',
  },
  dashboard: {
    path: '/pro/dashboard',
  },
  pipelineSettings: {
    path: '/pro/account/pipeline',
  },
  customerIntake: {
    path: '/pro/intake/new',
  },
  customerIntakeSettings: {
    path: '/pro/account/intake/settings',
  },
  onlineBookingSettings: {
    path: '/pro/account/online_booking/settings',
  },
  onlineBookingOnboarding: {
    path: '/pro/online_booking/onboarding',
  },
  onlineBookingPreview: {
    path: (uuid: string) => `/pro/account/online_booking/preview/${uuid}`,
  },
  priceBookEditService: {
    path: (uuid: string) => `/app/price_book/services/${uuid}`,
  },
  priceBookEstimateTemplatesCategory: {
    path: (uuid: string) => `/price_book${ROUTES.ESTIMATE_TEMPLATES}/category/${uuid}`,
  },
  priceBookEstimateTemplateAdd: {
    path: (uuid: string) => `/price_book${ROUTES.ESTIMATE_TEMPLATES}/category/${uuid}/templates/new`,
  },
  priceBookEstimateTemplateEdit: {
    path: (templateUuid: string) => `/price_book${ROUTES.ESTIMATE_TEMPLATES}/${templateUuid}`,
  },
  leads: {
    path: '/pro/leads/new',
  },
  lead: {
    path: (uuid: string) => `/pro/leads/${uuid}`,
  },
  onlineBooking: {
    path: '/pro/online_booking',
  },
  jobs: {
    path: '/pro/jobs',
  },
  estimates: {
    path: '/pro/estimates',
  },
  businessHours: {
    path: '/pro/account/business_hours',
  },
  jobDetails: {
    path: (uuid: string) => `/pro/jobs/${uuid}`,
  },
  estimatesDetails: {
    path: (uuid: string) => `/pro/estimates/${uuid}`,
  },
  customerDetails: {
    path: (uuid: string) => `/pro/customers/${uuid}`,
  },
  equipmentDetails: {
    path: (uuid: string) => `/app/equipment/${uuid}`,
  },
  customers: {
    path: '/pro/customers',
  },
  customersListView: {
    path: '/pro/customers/list',
  },
  jobsListView: {
    path: '/pro/customers/jobs',
  },
  estimatesListView: {
    path: '/pro/customers/estimates',
  },
  getStarted: {
    path: '/app/get_started',
  },
  myMoney: {
    path: '/pro/my_money',
  },
  map: {
    path: '/pro/map',
  },
  quickbooks: {
    path: '/pro/account/quickbooks_online',
  },
  pipeline: {
    path: '/app/pipeline',
  },
  timeSheet: {
    path: '/pro/time_tracking',
  },
  inbox: {
    calls: {
      path: '/pro/inbox/calls',
    },
    customers: {
      path: '/pro/inbox/categories/customers',
    },
  },
} as const;

export default url;
